import React from 'react';
import { FormattedMessage } from '../../../../util/reactIntl';
import {
  CheckIcon,
  ShieldCheckIcon,
  PhoneIcon,
  WhatsAppIcon,
  EmailIcon,
  HelpCircleIcon,
} from '../ListingIcons/ListingIcons';
import css from './BookingPanel.module.css';

const PHONE_NUMBER = '+4915730977660';
const PHONE_DISPLAY = '+49 157 30 97 76 60';
const WHATSAPP_LINK = 'https://wa.me/4915730977660';
const EMAIL = 'booking@socialbnb.de';
const ALEX_AVATAR =
  'https://res.cloudinary.com/dlcacck3a/image/upload/w_92,h_92,c_fill,g_face,q_auto:best,f_auto/v1769083002/socialbnb/containers/OldSTLandingPage/sections/QuickMenu/images/01_Alex_wide.webp';

const TrustItem = ({ children }) => (
  <li className={css.trustItem}>
    <span className={css.trustIcon}>
      <CheckIcon className={css.trustIconSvg} size={16} />
    </span>
    {children}
  </li>
);

const BookingPanel = ({ children }) => (
  <div className={css.root}>
    <div className={css.bookingCard}>
      {children}

      <ul className={css.trustList}>
        <TrustItem>
          <FormattedMessage id="BookingPanel.trustNoCharge" />
        </TrustItem>
        <TrustItem>
          <FormattedMessage id="BookingPanel.trustFreeCancellation" />
        </TrustItem>
        <TrustItem>
          <FormattedMessage id="BookingPanel.trustFullRefund" />
        </TrustItem>
      </ul>

      <a href="#absicherung" className={css.policyLink}>
        <ShieldCheckIcon className={css.policyIconSvg} size={16} />
        <FormattedMessage id="BookingPanel.packageTourLink" />
      </a>
    </div>

    <div className={css.contactCard}>
      <div className={css.contactHeader}>
        <img
          className={css.contactAvatar}
          src={ALEX_AVATAR}
          alt=""
          width={46}
          height={46}
          loading="lazy"
          decoding="async"
        />
        <div>
          <div className={css.contactTitle}>
            <FormattedMessage id="BookingPanel.contactTitle" />
          </div>
          <div className={css.contactSubtitle}>
            <FormattedMessage id="BookingPanel.contactSubtitle" />
          </div>
        </div>
      </div>

      <div className={css.contactActions}>
        <a href={`tel:${PHONE_NUMBER}`} className={css.contactBtnFull} data-elbaction="click:click bookingPhoneBtn">
          <PhoneIcon className={css.contactBtnIcon} size={17} />
          <span className={css.contactBtnLabel}>
            <FormattedMessage id="BookingPanel.callLabel" values={{ phone: PHONE_DISPLAY }} />
          </span>
        </a>
        <div className={css.contactBtnRow}>
          <a
            href={WHATSAPP_LINK}
            target="_blank"
            rel="noopener noreferrer"
            className={css.contactBtnHalf}
            data-elbaction="click:click bookingWhatsappBtn"
          >
            <WhatsAppIcon className={css.contactBtnIcon} size={17} />
            <span className={css.contactBtnLabel}>WhatsApp</span>
          </a>
          <a href={`mailto:${EMAIL}`} className={css.contactBtnHalf} data-elbaction="click:click bookingContactBtn">
            <EmailIcon className={css.contactBtnIcon} size={17} />
            <span className={css.contactBtnLabel}>
              <FormattedMessage id="BookingPanel.emailLabel" />
            </span>
          </a>
        </div>
      </div>
    </div>

    <div className={css.trustBox}>
      <div className={css.trustBoxTitle}>
        <HelpCircleIcon className={css.trustBoxIcon} size={18} />
        <FormattedMessage id="BookingPanel.trustBoxTitle" />
      </div>

      <div className={css.trustQ}>
        <div className={css.trustQTitle}>
          <FormattedMessage id="BookingPanel.trustQ1Title" />
        </div>
        <div className={css.trustQText}>
          <FormattedMessage
            id="BookingPanel.trustQ1Text"
            values={{
              strong: chunks => <strong className={css.strong}>{chunks}</strong>,
            }}
          />
        </div>
      </div>

      <div className={css.trustQ}>
        <div className={css.trustQTitle}>
          <FormattedMessage id="BookingPanel.trustQ2Title" />
        </div>
        <div className={css.trustQText}>
          <FormattedMessage
            id="BookingPanel.trustQ2Text"
            values={{
              strong: chunks => <strong className={css.strong}>{chunks}</strong>,
            }}
          />
        </div>
      </div>

      <div className={css.trustQLast}>
        <div className={css.trustQTitle}>
          <FormattedMessage id="BookingPanel.trustQ3Title" />
        </div>
        <div className={css.trustQText}>
          <FormattedMessage
            id="BookingPanel.trustQ3Text"
            values={{
              strong: chunks => <strong className={css.strong}>{chunks}</strong>,
            }}
          />
        </div>
      </div>
    </div>
  </div>
);

export default BookingPanel;
